import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ReferencePeriodModel extends Model {
  static reducer(action, ReferencePeriodModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.ReferencePeriod.schema:
        action.payload.forEach((payload) => {
          const dbData = ReferencePeriodModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ReferencePeriodModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ReferencePeriodModel.modelName = "ReferencePeriodModel";

ReferencePeriodModel.fields = {
  id: attr(),
};

export default ReferencePeriodModel;